export default "__VITE_ASSET__d918eb1e__"